import { useEffect, useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Receipt, Download } from "lucide-react";

export default function SchoolInvoicesPage() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get("/v2/invoices?limit=50").then((r) => {
      setItems(r.data.items || []);
      setTotal(r.data.total || 0);
    });
  }, []);

  const grandTotal = items.reduce((s, x) => s + (x.total || 0), 0);

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        <p className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">
          Billing
        </p>
        <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tighter text-[#0A192F]">
          Invoices
        </h1>
        <p className="mt-2 text-slate-500 text-sm">
          {total} invoices · ₹{grandTotal.toLocaleString()} grand total
        </p>

        <div className="mt-8 rounded-xl bg-white border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-[11px] uppercase tracking-[0.18em] text-slate-500">
              <tr>
                <th className="text-left px-5 py-3">Number</th>
                <th className="text-left px-5 py-3">Event</th>
                <th className="text-left px-5 py-3">Status</th>
                <th className="text-right px-5 py-3">Subtotal</th>
                <th className="text-right px-5 py-3">Tax</th>
                <th className="text-right px-5 py-3">Total</th>
                <th className="text-left px-5 py-3">Issued</th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((inv) => (
                <tr key={inv.id} className="border-t border-slate-100" data-testid={`invoice-${inv.number}`}>
                  <td className="px-5 py-3 font-mono text-xs text-[#0A192F]">{inv.number}</td>
                  <td className="px-5 py-3 text-slate-600 text-xs">{inv.event_id?.replace("event-", "") || "—"}</td>
                  <td className="px-5 py-3">
                    <span className={`text-[10px] uppercase tracking-[0.18em] font-bold px-2 py-0.5 rounded-full ${
                      inv.status === "paid" ? "bg-emerald-100 text-emerald-700"
                      : inv.status === "void" ? "bg-slate-100 text-slate-600"
                      : "bg-[#D4AF37]/15 text-[#0A192F]"
                    }`}>{inv.status}</span>
                  </td>
                  <td className="px-5 py-3 text-right text-slate-700">₹{inv.subtotal?.toLocaleString() || 0}</td>
                  <td className="px-5 py-3 text-right text-slate-500">₹{inv.tax?.toLocaleString() || 0}</td>
                  <td className="px-5 py-3 text-right font-semibold text-[#0A192F]">₹{inv.total?.toLocaleString() || 0}</td>
                  <td className="px-5 py-3 text-xs text-slate-500">{inv.issued_at ? new Date(inv.issued_at).toLocaleDateString() : "—"}</td>
                  <td className="px-5 py-3 text-right">
                    <Button variant="ghost" size="sm" onClick={() => window.print()} data-testid={`download-invoice-${inv.number}`}>
                      <Download className="h-4 w-4" />
                    </Button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={8} className="text-center py-12">
                  <Receipt className="h-5 w-5 text-slate-400 mx-auto" />
                  <p className="mt-2 text-sm text-slate-500">No invoices yet.</p>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
